export const PLANNING_SETTINGS_COPY = {
  tabsLabel: "Planning settings",
  title: "Planning",
  generalTab: "General",
  agentTab: "Agent",
  automationTab: "Automation",
  planningLabel: "Planning",
  planningReviewHelper:
    "An agent plans each task that enters Backlog. It scores Clarity, Complexity, and Verifiability. Confidence is the weakest of those scores.",
  autoStartLabel: "Auto-start",
  autoStartReviewHelper: "Auto-start tasks when the first score is 3/3.",
  autoStartPlanningOffHelper: "Turn Planning on to use Auto-start.",
  autoStartNoBoardHelper: "Set up a board before you turn Auto-start on.",
  autoStartStartOnLabel: "Start on",
  healthLabel: "Health",
  healthReady: "Ready",
  healthDisabled: "Off",
  healthReadyHelper: "An agent plans each task that enters Backlog.",
  healthDisabledHelper: "Tasks wait in Backlog as written. Nobody plans them.",
  save: "Save",
  saving: "Saving",
  saveError: "Could not save Planning settings.",
  loading: "Loading Planning settings.",
  loadError: "Could not load Planning settings.",
  retry: "Retry",
  automationEmpty: "This automation has no steps yet.",
  automationLoading: "Loading the steps.",
  automationError: "Could not load the steps.",
} as const;
